import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { SubscriptionOptions } from './types';

type Variables = { address: string; startDate: Date };
type Response = SubscriptionOptions;

export function getCheapestModelKey(periodOptions: object | null | undefined) {
  if (!periodOptions) return undefined;

  return Object.keys(periodOptions)
    .filter((key) => (periodOptions as any)[key]?.cheapestOption)
    .sort((a, b) => {
      const aCost = (periodOptions as any)[a].cheapestOption.cost;
      const bCost = (periodOptions as any)[b].cheapestOption.cost;
      return aCost - bCost;
    })[0];
}

export const useSubscriptionOptions = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['subscriptionOptions'],
  fetcher: ({ address, startDate }) => {
    return client
      .get(
        `v2/subscriptions/options?address=${address}&start_date=${startDate.toISOString()}`
      )
      .then((response) => {
        return response.data.data;
      });
  },
});
